<template>
	<div>
		<!-- <TilteParallax image="https://cdn.hipwallpaper.com/i/7/54/QSWLXT.png"> -->
		<TilteParallax
			image="https://apps.pinturasacuario.mx/assets/store/images/customer/search.jpg"
		>
			<template v-slot:title>
				Ordenes de compra
			</template>

			<template v-slot:subtitle v-if="purchaceorders.length">
				{{ `${purchaceorders.length} ordenes de compra.` }}
			</template>

			<template v-slot:menu>
				<v-menu offset-y>
					<template v-slot:activator="{ on, attrs }">
						<v-btn
							fab
							v-on="on"
							elevation="5"
							v-bind="attrs"
							color="default"
						>
							<v-icon>
								mdi-dots-vertical
							</v-icon>
						</v-btn>
					</template>
					<v-list>
						<template>
							<v-list-item
								@click="
									$router.push({
										name: 'PurchaseCreate',
									})
								"
							>
								<v-list-item-title>
									Nuevo
								</v-list-item-title>
							</v-list-item>
						</template>
					</v-list>
				</v-menu>
			</template>
		</TilteParallax>

		<v-container fluid class="pt-0">
			<v-row justify="center" class="pt-0 mt-0">
				<v-col cols="12" md="10">
					<v-card
						outlined
						:class="[
							$vuetify.breakpoint.smAndDown ? 'pa-0' : 'pa-4',
							'pt-0',
							'pb-0',
						]"
						:loading="purchaceordersGeting"
					>
						<!-- <v-card-title
							class="d-flex justify-end align-center"
							v-if="!purchaceordersGeting"
						>
							<template v-if="purchaceorders.length">
								<router-link :to="{ name: 'PurchaseCreate' }">
									<v-btn color="primary" class="mt-2">
										nuevo
									</v-btn>
								</router-link>
							</template>
						</v-card-title> -->

						<v-card-text
							:class="[{ 'pa-0': $vuetify.breakpoint.smAndDown }]"
						>
							<v-container fluid v-if="!purchaceordersGeting">
								<template v-if="purchaceorders.length">
									<v-row
										v-for="purchaceorder in purchaceorders"
									>
										<v-col cols="12" class="pa-0 mb-3">
											<ItemPurchaceOrder
												:purchaceorder="purchaceorder"
											></ItemPurchaceOrder>
										</v-col>
									</v-row>
								</template>

								<template v-else>
									<v-row>
										<v-col
											cols="12"
											class="d-flex justify-center flex-column align-center"
											style="height: 60vh;"
										>
											<h2>
												Aún no tienes ordenes de compra
											</h2>

											<p class="text-center">
												Puedes realizar tu primer orden
												de compra haciendo click en el
												siguiente botón
											</p>

											<router-link
												:to="{ name: 'PurchaseCreate' }"
											>
												<v-btn
													color="primary"
													class="mt-2"
												>
													nuevo
												</v-btn>
											</router-link>
										</v-col>
									</v-row>
								</template>
							</v-container>
						</v-card-text>
					</v-card>
				</v-col>
			</v-row>
		</v-container>

		<Wellcome v-if="wellcomeMessageShow"></Wellcome>
	</div>
</template>

<script>
import moment from "moment";
import { mapState } from "vuex";
import { EventBus } from "@/main";
import Wellcome from "@/components/Wellcome";
import ItemPurchaceOrder from "@/components/PurchaceOrder/Item";
import TilteParallax from "@/components/TilteParallax";

export default {
	name: "Index",

	components: { TilteParallax, Wellcome, ItemPurchaceOrder },

	data() {
		return {
			data: {
				salesorders: [],
			},

			selected: [],

			ui: {
				filters: {
					search: null,
					date_end: null,
					date_start: null,
				},

				headers: [
					{ text: "#", value: "id" },
					// { text: "Articulos", value: "articles" },
					{ text: "Metodo de envío", value: "shipping_method.name" },
					{ text: "Fecha", value: "created_at" },
					{ text: "Estado", value: "status.name" },
					{ text: "Acciones", value: "actions" },
				],
			},
		};
	},

	created() {
		this.$store.dispatch("getPurchaceOrders");
	},

	methods: {
		async get() {
			this.$store.dispatch("getPurchaceOrders");
		},

		hasRol(rolIdRequired) {
			if (
				this.$store.state.acount.user.roles.find(
					(rol) => rol.id === rolIdRequired
				) === undefined
			) {
				return false;
			}

			return true;
		},
	},

	computed: {
		...mapState({
			purchaceordersGeting: (state) => state.ui.purchaceordersGeting,

			purchaceorders: (state) => state.purchaceorders,

			wellcomeMessageShow() {
				if (
					(localStorage.getItem("salesorder") === undefined ||
						localStorage.getItem("salesorder") === null) &&
					this.purchaceorders.length === 0 &&
					!this.purchaceordersGeting
				) {
					return true;
				}
				return false;
			},
		}),

		Items() {
			let items = this.purchaceorders;

			if (this.ui.filters) {
				// Filter Date Start
				if (this.ui.filters.date_start != null) {
					items = items.filter(
						(item) =>
							moment(item.created_at, [
								"YYYY-MM-DD h:mm:ss a",
							]).format("YYYY-MM-DD") >=
							this.ui.filters.date_start
					);
				}

				// Filter Date End
				if (this.ui.filters.date_end != null) {
					items = items.filter(
						(item) =>
							moment(item.created_at, [
								"YYYY-MM-DD h:mm:ss a",
							]).format("YYYY-MM-DD") <= this.ui.filters.date_end
					);
				}
			}

			return items;
		},
	},
};
</script>

<style lang="css" scoped></style>
